
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function MicroKnowledge() {
  const [currentFact, setCurrentFact] = useState(0);
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/blogs');
  };

  const facts = [
    {
      icon: "🏝️",
      title: "Did you know?",
      fact: "The world's smallest inhabited river island, Umananda, is in Assam!"
    },
    {
      icon: "🦏",
      title: "Amazing Fact!",
      fact: "Kaziranga National Park is home to two-thirds of the world's one-horned rhinoceros population."
    },
    {
      icon: "🎭",
      title: "Cultural Heritage",
      fact: "Assamese silk, particularly Muga silk, is known as the golden silk and is found only in Assam."
    },
    {
      icon: "🌿",
      title: "Natural Wonder",
      fact: "Meghalaya receives the highest rainfall in India, with Mawsynram being one of the wettest places on Earth."
    },
    {
      icon: "🎵",
      title: "Musical Tradition",
      fact: "The traditional Assamese instrument 'Dhol' is made from a single piece of wood and plays a central role in Bihu celebrations."
    }
  ];

  const nextFact = () => {
    setCurrentFact((prev) => (prev + 1) % facts.length);
  };

  const prevFact = () => {
    setCurrentFact((prev) => (prev - 1 + facts.length) % facts.length);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Micro-Knowledge Hub
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover bite-sized insights, local wisdom, and practical knowledge shared by our community members
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Knowledge Cards */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-lightbulb-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Traditional Recipes</h3>
            <p className="text-gray-600 mb-6">
              Authentic recipes passed down through generations, with modern adaptations for today's kitchen.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>127 recipes shared</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-plant-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Herbal Remedies</h3>
            <p className="text-gray-600 mb-6">
              Natural healing practices and medicinal plant knowledge from local healers and practitioners.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>89 remedies documented</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-hammer-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Craft Techniques</h3>
            <p className="text-gray-600 mb-6">
              Step-by-step guides to traditional crafts, from weaving to pottery, shared by master artisans.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>156 techniques shared</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-seedling-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Farming Tips</h3>
            <p className="text-gray-600 mb-6">
              Sustainable farming practices and seasonal advice from experienced farmers in the region.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>203 tips shared</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-music-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Folk Songs</h3>
            <p className="text-gray-600 mb-6">
              Traditional songs, their meanings, and cultural significance preserved through community sharing.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>78 songs documented</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-map-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Local History</h3>
            <p className="text-gray-600 mb-6">
              Stories and historical facts about local places, landmarks, and significant events in the community.
            </p>
            <div className="flex items-center text-red-700 font-medium">
              <span>145 stories shared</span>
              <i className="ri-arrow-right-line ml-2"></i>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Explore More Knowledge?
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Join thousands of community members sharing and discovering valuable insights every day
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/citizen-submission')}
              className="bg-red-700 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-800 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Share Your Knowledge
            </button>
            <button 
              onClick={handleLearnMore}
              className="border-2 border-red-700 text-red-700 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-700 hover:text-white transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </button>
          </div>
        </div>

        {/* Fact Display */}
        <div className="max-w-4xl mx-auto mt-16">
          <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-4 left-4 text-6xl">{facts[currentFact].icon}</div>
              <div className="absolute bottom-4 right-4 text-6xl">{facts[currentFact].icon}</div>
            </div>

            <div className="relative z-10">
              <div className="text-6xl mb-6">{facts[currentFact].icon}</div>
              <h3 className="text-2xl font-bold text-red-700 mb-4">{facts[currentFact].title}</h3>
              <p className="text-xl md:text-2xl text-gray-800 font-medium leading-relaxed">
                {facts[currentFact].fact}
              </p>
            </div>

            {/* Navigation Arrows */}
            <button 
              onClick={prevFact}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/80 hover:bg-white rounded-full flex items-center justify-center text-red-700 hover:text-red-800 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button 
              onClick={nextFact}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/80 hover:bg-white rounded-full flex items-center justify-center text-red-700 hover:text-red-800 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>

          {/* Fact Indicators */}
          <div className="flex justify-center mt-8 gap-3">
            {facts.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentFact(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentFact ? 'bg-red-700 w-8' : 'bg-red-200 hover:bg-red-300'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Horizontal Scroll Alternative */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">More Quick Facts</h3>
          <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide">
            {facts.map((fact, index) => (
              <div key={index} className="flex-shrink-0 w-80 bg-white border border-red-100 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-3">{fact.icon}</div>
                <h4 className="font-semibold text-red-700 mb-2">{fact.title}</h4>
                <p className="text-gray-700 text-sm leading-relaxed">{fact.fact}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
